// hooks/useUserWorkspace.js
import { useState, useCallback } from "react";
import {
  fetchWorkspaceRoleApi,
  fetchWorkspacesByUserIdApi,
} from "../service/api";

export const useUserWorkspace = (userId, defaultWorkspaceId, apiUrl) => {
  const [defaultWorkspaceRole, setDefaultWorkspaceRole] = useState(null);
  const [loadingWorkspaceRole, setLoadingWorkspaceRole] = useState(false);
  const [userWorkspace, setUserWorkspace] = useState();
  const [role, setRole] = useState(null);
  const [isRoleLoading, setIsRoleLoading] = useState(false);

  const fetchWorkspaceRole = useCallback(async () => {
    if (!userId || !defaultWorkspaceId) {
      setDefaultWorkspaceRole(null);
      return;
    }
    setLoadingWorkspaceRole(true);
    try {
      const role = await fetchWorkspaceRoleApi(
        userId,
        defaultWorkspaceId,
        apiUrl,
      );
      setDefaultWorkspaceRole(role);
    } catch (error) {
      console.error("Error fetching workspace role:", error);
      setDefaultWorkspaceRole(null);
    } finally {
      setLoadingWorkspaceRole(false);
    }
  }, [apiUrl, userId, defaultWorkspaceId]);

  const fetchUserWorkspaces = useCallback(async () => {
    try {
      const workspacesData = await fetchWorkspacesByUserIdApi(userId, apiUrl);
      setUserWorkspace(workspacesData);
    } catch (error) {
      console.error("Error fetching workspaces:", error);
      setRole(null);
    } finally {
      setIsRoleLoading(false);
    }
  }, [apiUrl, userId]);

  return {
    defaultWorkspaceRole,
    loadingWorkspaceRole,
    userWorkspace,
    role,
    isRoleLoading,
    fetchWorkspaceRole,
    fetchUserWorkspaces,
  };
};
